'use client'
import React from 'react'
import ProductsCardClient from './ProductsCardClient'
import { Product } from './ProductsCard'

interface JsonProductsCardProps {
    products: string | Product[] | any
    children?: React.ReactNode
}

const JsonProductsCard = ({ products, children }: JsonProductsCardProps) => {
    try {
        let productsArray: Product[] = []
        if (Array.isArray(products)) {
            productsArray = products
        } else if (typeof products === 'string') {
            let cleaned = products.trim()
            if ((cleaned.startsWith('"') && cleaned.endsWith('"')) || 
                (cleaned.startsWith("'") && cleaned.endsWith("'"))) {
                cleaned = cleaned.slice(1, -1)
            }
            cleaned = cleaned.replace(/\\"/g, '"').replace(/\\n/g, '\n')
            productsArray = JSON.parse(cleaned)
        } else if (products && typeof products === 'object') {
            if (Array.isArray(products)) {
                productsArray = products
            } else {
                productsArray = [products]
            }
        } else if (products === null || products === undefined) {
            throw new Error('Products is null or undefined')
        } else {
            throw new Error(`Invalid products format: ${typeof products}`)
        }
        
        if (!Array.isArray(productsArray)) {
            throw new Error('Products must be an array')
        }
        
        productsArray = productsArray.filter((p: any) => p && (p.id || p.name))
        
        if (productsArray.length === 0) {
            return (
                <div className='my-4 p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg'>
                    <p className='text-sm text-yellow-600 dark:text-yellow-400'>
                        Không có sản phẩm hợp lệ nào
                    </p>
                </div>
            )
        }
        
        return <ProductsCardClient products={productsArray} />
    } catch (error) {
        return (
            <div className='my-4 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg'>
                <p className='text-sm text-red-600 dark:text-red-400'>
                    Lỗi parse JSON sản phẩm: {error instanceof Error ? error.message : 'Invalid JSON'}
                </p>
                <details className='mt-2'>
                    <summary className='text-xs cursor-pointer'>Chi tiết lỗi</summary>
                    <div className='mt-2 text-xs space-y-2'>
                        <p><strong>Type:</strong> {typeof products}</p>
                        <p><strong>Is Array:</strong> {Array.isArray(products) ? 'Yes' : 'No'}</p>
                        <pre className='overflow-auto bg-white dark:bg-zinc-900 p-2 rounded'>
                            {typeof products === 'string' 
                                ? products 
                                : JSON.stringify(products, null, 2)}
                        </pre>
                    </div>
                </details>
            </div>
        )
    }
}

export default JsonProductsCard

